import * as React from "react";
import GoBackButton from "../../Misc/GoBackButton";
import FilterBox from "../ProductWise/FilterBox";
import CustomerGrowth from "./CustomerGrowth";
import NewCustomers from "./NewCustomers";
import NullCustomers from "./NullCustomers";
import TopCustomers from "./TopCustomers";
import TopCustomersCount from "./TopCustomersCount";

interface Props {}

const CustomerWise: React.FC<Props> = () => {
  const today = new Date(Date.now()).toISOString().split("T")[0];
  const [fromDate, setFromDate] = React.useState(
    localStorage.getItem("CustomerWiseFromDate") ||
      new Date(today.slice(0, 7)).toISOString().split("T")[0]
  );
  const [toDate, setToDate] = React.useState(
    localStorage.getItem("CustomerWiseToDate") || today
  );
  const [orderBy, setOrderBy] = React.useState(
    localStorage.getItem("CustomerWiseOrderBy") || "DESC"
  );

  React.useEffect(() => {
    localStorage.setItem("CustomerWiseFromDate", fromDate);
    localStorage.setItem("CustomerWiseToDate", toDate);
    localStorage.setItem("CustomerWiseOrderBy", orderBy);
  }, [fromDate, toDate, orderBy]);
  return (
    <>
      <GoBackButton />
      <FilterBox
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "50% 50%",
          gridColumnGap: "20px",
        }}
      >
        <NewCustomers />
        <TopCustomers fromDate={fromDate} toDate={toDate} orderBy={orderBy} />
        <TopCustomersCount
          fromDate={fromDate}
          toDate={toDate}
          orderBy={orderBy}
        />
        <CustomerGrowth />
        <NullCustomers />
      </div>
    </>
  );
};

export default CustomerWise;
